import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { putBrandStorePrice } from '../../../services/StorePriceCode/getPriceCode';

const StoreConfigPriceDefault = ({
  activePriceStatus,
  setActivePriceStatus,
  editData,
  sendDataToStoreConfig,
  brandId,
  storeId
}) => {
  const handlePress = (e) => {
    const newStatus = e.value;

    if (!newStatus) return; // Prevent disabling the switch (only one default allowed)

    const updatedData = {
      price: {
        id: editData.price.id,
      },
      id: editData.id,
      status: true,
      default: newStatus,
    };

    putBrandStorePrice(brandId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          sendDataToStoreConfig({
            success: true,
          });
          setActivePriceStatus(editData.id); // Set current as active
        }
      })
      .catch((err) => {
        console.error('Error updating brand store price:', err);
      });
  };

  return (
    <div
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 10,
        marginLeft: 5,
      }}>
      <div
        style={{
          flexDirection: 'row',
          position: 'relative',
          height:
              10,
          borderRadius: 30,
          elevation: 2,
          backgroundColor: '#efebf0',
          width: '100%',
        }}>
        <InputSwitch checked={activePriceStatus} onChange={handlePress} />
      </div>
    </div>
  );
};

export default StoreConfigPriceDefault;
